import { create } from 'zustand';

const useMedicationSelectionStore = create((set) => ({
  activeDrug: null,
  setActiveDrug: (drug) => set({ activeDrug: drug }),
  clearActiveDrug: () => set({ activeDrug: null }),
}));

export default useMedicationSelectionStore;

